
import React from "react";
import {
  Button,
  Col,
  Divider,
  Drawer,
  Empty,
  Row,
  Space,
  Table,
  Tabs,
  Tag,
} from "antd";
import config from "../../config/app.config";
import { tagsBageStatus, tagsTypeBage } from "../../helpers/tagsBage";
import { FilterBankGroup, FilterMerchang } from "../../helpers/filterDataItem";
import moment from "moment";
import { calculateAccountUsage } from "../../helpers/calculate";
import {
  CloseOutlined,
} from "@ant-design/icons";

const { TabPane } = Tabs;

export class DrawerStatement extends React.Component {
  state = {
    loading: false,
    activeTab: "bankAccounts",
    bankGroup: "",
    isMerchang: "",
    isArrayData: [],
  };

  handleTabChange = (key) => {
    const { isData, resBankGroupData, resAllDataMerchang } = this.props;
    let isArray = Array.isArray(isData?.Botlog_limittimes)
      ? isData?.Botlog_limittimes
      : [];
    let bankGroup = FilterBankGroup(
      resBankGroupData,
      isData?.bankAccountGroupId
    );
    if (key) {
      let isMerchang = FilterMerchang(resAllDataMerchang, isData?.merchantId);
      this.onCalculateAccountUsage(isData);
      this.setState({ bankGroup: bankGroup?.name });
      this.setState({ isMerchang: isMerchang?.name, isArrayData: isArray });
    }
    this.setState({ activeTab: key, isArrayData: isArray });
  };

  onCalculateAccountUsage(date) {
    let o = calculateAccountUsage(date);
    return o;
  }

  handleFormatJsonDAta = (jsonData) => {
    let parsedData = [];
    try {
      // แปลงข้อมูล JSON String ให้เป็น Array
      parsedData = JSON.parse(jsonData);
    } catch (e) {
      console.error("Failed to parse transaction data:", e);
      return [];
    }
    if (!Array.isArray(parsedData) || parsedData.length === 0) {
      return [];
    }
    const sortedData = [...parsedData].sort(
      (a, b) =>
        moment(b.transactionDateTime).valueOf() -
        moment(a.transactionDateTime).valueOf()
    );
    this.setState({ isArrayData: sortedData });
  };

  transactionColumns = [
    {
      title: <span className="text-truncate">{this.props.t("Pull Description")}</span>,
      dataIndex: "name_bot",
      key: "name_bot",
      render: (_, record) => {
        return <span>{this.props.t(record?.name_bot)}</span>;
      },
    },
    {
      title: <span className="text-truncate">{this.props.t("Date")}</span>,
      dataIndex: "created_at",
      key: "created_at",
      render: (_, record) => {
        let item = record;
        let date = moment(item?.created_at).format("YYYY-MM-DD");
        let time = moment(item?.created_at).format("HH:mm");
        return (
          <span title={moment(item?.created_at).format("YYYY-MM-DD HH:mm")}>
            <span>{date}</span>{" "}
            <span style={{ fontWeight: "600" }}>{time}</span>
          </span>
        );
      },
    },
    {
      title: <span className="text-truncate">{this.props.t("Status")}</span>,
      dataIndex: "bot_status",
      key: "bot_status",
      render: (_, record) => {
        let item = record;
        return (
          <Tag color={tagsBageStatus(item?.bot_status)}>{item?.bot_status}</Tag>
        );
      },
    },

    {
      title: <span className="text-truncate">{this.props.t("transactions")}</span>,
       dataIndex: "getupdate_data",
      key: "getupdate_data",
      render: (record) => {
        return <>{this.props.t("Deposit transactions", {transactions: record})}</>;
      },
    },
  ];

  onClose =()=> {
    const { onClose } = this.props;
    this.setState({activeTab: "bankAccounts",}, () =>{
      onClose()
    })

  }

  render() {
    const { open, t,  isData } = this.props;
    if (!isData) {
      return
    }
    return (
      <>
        <Drawer
          title={t("Details")}
          placement={"right"}
          width={800}
          closable={false}
          onClose={this.onClose}
          open={open}
          extra={
            <Space>
              <Button
                icon={
                  <CloseOutlined
                    className="fs-sm-12"
                    style={{
                      fontSize: "12px",
                      color: "#3eacff",
                    }}
                  />
                }
                size="small"
                shape="circle"
                onClick={this.onClose}
              />
            </Space>
          }
        >
          <div className="p-3">
            <div style={{ margin: "0 auto" }}>
              <Tabs
                activeKey={this.state.activeTab}
                onChange={this.handleTabChange}
                className="custom-tabs"
              >
                <TabPane tab={t("Bank account")} key="bankAccounts">
                  <div className="bank-account-details-wrapper">
                    
                    <div className="detail-item-list">
                      <Row gutter={[16, 8]} className="detail-item">
                        <Col span={10} className="detail-label">
                          {t("Bank account")} :
                        </Col>
                        <Col span={14} className="detail-value">
                          {isData?.bank?.bankNameTh || "-"}
                        </Col>
                      </Row>
                      <Row gutter={[16, 8]} className="detail-item">
                        <Col span={10} className="detail-label">
                          {t("Account No.")} :
                        </Col>
                        <Col span={14} className="detail-value">
                          {isData?.accountNumber || "-"}
                        </Col>
                      </Row>
                      <Row gutter={[16, 8]} className="detail-item">
                        <Col span={10} className="detail-label">
                          {t("Name")} :
                        </Col>
                        <Col span={14} className="detail-value">
                          {isData?.accountName || "-"}
                        </Col>
                      </Row>
                      <Row gutter={[16, 8]} className="detail-item">
                        <Col span={10} className="detail-label">
                          {t("Type")} :
                        </Col>
                        <Col span={14} className="detail-value">
                          {isData?.accountType ? (
                            <Tag color={tagsTypeBage(isData?.accountType)}>
                              {isData?.accountType}
                            </Tag>
                          ) : (
                            "-"
                          )}
                        </Col>
                      </Row>
                      <Row gutter={[16, 8]} className="detail-item">
                        <Col span={10} className="detail-label">
                          {t("Channel")} :
                        </Col>
                        <Col span={14} className="detail-value">
                          {isData?.channel || "-"}
                        </Col>
                      </Row>
                      <Row gutter={[16, 8]} className="detail-item">
                        <Col span={10} className="detail-label">
                          {t("Status")} :
                        </Col>
                        <Col span={14} className="detail-value">
                          {isData?.status_bank ? (
                            <Tag
                              color={
                                isData?.status_bank === "Inactive"
                                  ? "red"
                                  : isData?.status_bank === "Active"
                                  ? "green"
                                  : isData?.status_bank === "Vault"
                                  ? "purple"
                                  : "blue"
                              }
                            >
                              {isData?.status_bank}
                            </Tag>
                          ) : (
                            "-"
                          )}
                        </Col>
                      </Row>
                      <Row gutter={[16, 8]} className="detail-item">
                        <Col span={10} className="detail-label">
                          {t("Bank account group")} :
                        </Col>
                        <Col span={14} className="detail-value">
                          {this.state.bankGroup || "ไม่มีข้อมูล"}
                        </Col>
                      </Row>
                      <Row gutter={[16, 8]} className="detail-item">
                        <Col span={10} className="detail-label">
                          {t("Bank Group ID")} :
                        </Col>
                        <Col span={14} className="detail-value">
                          {isData?.bankAccountGroupId || "-"}
                        </Col>
                      </Row>
                      <Row gutter={[16, 8]} className="detail-item">
                        <Col span={10} className="detail-label">
                          {t("Level Bank")} :
                        </Col>
                        <Col span={14} className="detail-value">
                          {isData?.level_Bank || "-"}
                        </Col>
                      </Row>
                      <Row gutter={[16, 8]} className="detail-item">
                        <Col span={10} className="detail-label">
                          {t("Merchant")} :
                        </Col>
                        <Col span={14} className="detail-value">
                          {this.state.isMerchang || "-"}
                        </Col>
                      </Row>
                      <Row gutter={[16, 8]} className="detail-item">
                        <Col span={10} className="detail-label">
                          {t("merchant")} :
                        </Col>
                        <Col span={14} className="detail-value">
                          {isData?.merchantId || "-"}
                        </Col>
                      </Row>
                      <Row gutter={[16, 8]} className="detail-item">
                        <Col span={10} className="detail-label">
                          {t("balance")} :
                        </Col>
                        <Col span={14} className="detail-value">
                          {isData?.balance || "-"}
                        </Col>
                      </Row>
                      <Row gutter={[16, 8]} className="detail-item">
                        <Col span={10} className="detail-label">
                          {t("limit_Left")} :
                        </Col>
                        <Col span={14} className="detail-value">
                          {isData?.limit_Left || "-"}
                        </Col>
                      </Row>
                      <Row gutter={[16, 8]} className="detail-item">
                        <Col span={10} className="detail-label">
                          {t("telephoneNumber")} :
                        </Col>
                        <Col span={14} className="detail-value">
                          {isData?.telephoneNumber || "-"}
                        </Col>
                      </Row>
                      <Row gutter={[16, 8]} className="detail-item">
                        <Col span={10} className="detail-label">
                          {t("createdAt")} :
                        </Col>
                        <Col span={14} className="detail-value">
                          {moment(isData?.created_at).format(
                            "YYYY-MM-DD HH:mm:ss"
                          ) || "-"}
                        </Col>
                      </Row>
                      <Row gutter={[16, 8]} className="detail-item">
                        <Col span={10} className="detail-label">
                          {t("updatedAt")} :
                        </Col>
                        <Col span={14} className="detail-value">
                          {moment(isData?.updated_at).format(
                            "YYYY-MM-DD HH:mm:ss"
                          ) || "-"}
                        </Col>
                      </Row>
                      <Row gutter={[16, 8]} className="detail-item">
                        <Col span={10} className="detail-label">
                          {t("Already used")} :
                        </Col>
                        <Col span={14} className="detail-value">
                          {this.onCalculateAccountUsage(isData)} วัน
                        </Col>
                      </Row>
                    </div>
                  </div>
                </TabPane>
                <TabPane tab={t("ดึงยอด (10 ครั้งล่าสุด)")} key="transactions">
                  <div className="transaction-content-wrapper">
                    
                    <Table
                      dataSource={this.state.isArrayData}
                      style={{ borderTop: "none" }}
                      columns={this.transactionColumns}
                      className=""
                      pagination={false}
                      rowKey={(record, index) => index}
                      // expandable={{
                      //   expandedRowRender: (record) => {
                      //     try {
                      //       const transactions = JSON.parse(record?.old_data);
                      //       return (
                      //         <>
                      //           <div
                      //             className="row  body table-responsive"
                      //             style={{
                      //               background: "rgb(255 255 255)",
                      //               margin: "0 auto",
                      //             }}
                      //           >
                      //             <div className="col-12 p-0">
                      //               <div className=" p-3">
                      //                 <Divider
                      //                   orientation="left"
                      //                   children={
                      //                     <Text className="fs-sm-12" strong>
                      //                       <ClockCircleOutlined /> Transaction
                      //                       List
                      //                     </Text>
                      //                   }
                      //                 />
                      //               </div>
                      //               <Table
                      //                 locale={{
                      //                   emptyText: (
                      //                     <Empty
                      //                       image={Empty.PRESENTED_IMAGE_SIMPLE}
                      //                       description="No data"
                      //                     />
                      //                   ),
                      //                 }}
                      //                 dataSource={transactions}
                      //                 pagination={false}
                      //                 rowKey={(record, index) => index}
                      //                 style={{
                      //                   overflow: "auto",
                      //                 }}
                      //                 scroll={{ x: "max-content" }}
                      //                 columns={[
                      //                   {
                      //                     title: t("#"),
                      //                     key: "computed-id", // กำหนด key ที่ไม่ซ้ำกัน
                      //                     render: (text, record, index) => (
                      //                       <b>{index + 1}</b>
                      //                     ),
                      //                     width: 30,
                      //                   },
                      //                   {
                      //                     title: (
                      //                       <span className="text-truncate">
                      //                         {t("Date")}
                      //                       </span>
                      //                     ),
                      //                     dataIndex: "transactionDateTime",
                      //                     key: "transactionDateTime",
                      //                     render: (text) => {
                      //                       let date =
                      //                         moment(text).format("DD/MM/YYYY");
                      //                       let time =
                      //                         moment(text).format("HH:mm");

                      //                       return (
                      //                         <>
                      //                           <b>
                      //                             {date}{" "}
                      //                             <span
                      //                               style={{
                      //                                 fontWeight: "600",
                      //                               }}
                      //                             >
                      //                               {time}
                      //                             </span>
                      //                           </b>
                      //                         </>
                      //                       );
                      //                     },
                      //                   },
                      //                   {
                      //                     title: (
                      //                       <span className="text-truncate">
                      //                         {t("description")}
                      //                       </span>
                      //                     ),
                      //                     dataIndex: "description",
                      //                     key: "description",
                      //                     render: (text) => <b>{text}</b>,
                      //                   },
                      //                   {
                      //                     title: (
                      //                       <span className="text-truncate">
                      //                         {"จำนวน"}
                      //                       </span>
                      //                     ),
                      //                     dataIndex: "deposit",
                      //                     key: "deposit",
                      //                     render: (text) => (
                      //                       <span
                      //                         style={{
                      //                           color: "green",
                      //                           fontWeight: "600",
                      //                         }}
                      //                       >
                      //                         +{" "}
                      //                         {Intl.NumberFormat().format(
                      //                           text || 0
                      //                         )}
                      //                       </span>
                      //                     ),
                      //                   },
                      //                   {
                      //                     title: (
                      //                       <span className="text-truncate">
                      //                         {"คงเหลือ"}
                      //                       </span>
                      //                     ),
                      //                     dataIndex: "ledgerBalance",
                      //                     key: "ledgerBalance",
                      //                     render: (text) => (
                      //                       <b>
                      //                         {Intl.NumberFormat().format(
                      //                           text || 0
                      //                         )}
                      //                       </b>
                      //                     ),
                      //                   },
                      //                 ]}
                      //               />
                      //               <Divider />
                      //             </div>
                      //           </div>
                      //         </>
                      //       );
                      //     } catch (error) {
                      //       return (
                      //         <Text type="danger">
                      //           {t("The detailed information cannot be displayed.")}
                      //         </Text>
                      //       );
                      //     }
                      //   },
                      //   expandIcon: ({ expanded, onExpand, record }) => (
                      //     <div className="text-left">
                      //       <Button
                      //         shape="circle"
                      //         size="small"
                      //         onClick={(e) => onExpand(record, e)}
                      //         icon={
                      //           expanded ? (
                      //             <CloseOutlined
                      //               className="fs-sm-12"
                      //               style={{
                      //                 fontSize: "12px",
                      //               }}
                      //             />
                      //           ) : (
                      //             <AlignLeftOutlined
                      //               className="fs-sm-12"
                      //               style={{
                      //                 fontSize: "12px",
                      //               }}
                      //             />
                      //           )
                      //         }
                      //       />
                      //     </div>
                      //   ),
                      //   fixed: "right",

                      //   columnTitle: "Info",
                      //   childrenColumnName: "text-left",
                      //   columnWidth: "13%",
                      // }}
                      locale={{
                        emptyText: (
                          <Empty
                            image={Empty.PRESENTED_IMAGE_SIMPLE}
                            description="No data"
                          />
                        ),
                      }}
                    />
                  </div>
                </TabPane>
              </Tabs>
              <br />
              <Divider
                orientation="center"
                style={{ borderBlockStart: "0 #05050500" }}
              >
                <small style={{ color: "#888" }}>
                  Version: {config.version}
                </small>
              </Divider>
            </div>
          </div>
        </Drawer>
      </>
    );
  }
}
